import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { useState, useEffect } from "react";
import Customer from "../actions/customer";
import Controls from "./controls/Controls";
import useTable from "./customHelpers/useTable";
import { isAuth } from "../actions/auth";

const SaveCustomersFromFile = (props) => {
  const { addCustomersFromFile } = Customer();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const updatedColDefs = [
    ...props.file.colDefs,
    { id: "status", label: "Status" },
  ];
  const modifiedCustomers = props?.file?.data.map((order) => ({
    ...order,
    organization: isAuth()?.staffOrganizations[0].organization?.id,
  }));
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(
      modifiedCustomers.sort((a, b) =>
        a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0
      ),
      updatedColDefs,
      filterFn
    );
  const handleSubmit = () => {
    addCustomersFromFile(props?.file?.data).then((data) => {
      if (data.err) {
        props.NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        props.NotifyMessage({
          message: "Customers Added",
          type: "success",
        });
        props.setOpenPopupBulkSave(false);
        props.getAllCustomers();
      }
    });
  };

  return (
    <div>
      <TblContainer>
        <TblHead />
        <TableBody>
          {recordsAfterPagingAndSorting().map((item, index) => {
            if (!item.fullName) return null;
            const customerExists = props?.customers.some(
              (customer) =>
                  String(customer.phoneNo).trim() === String(item.phoneNo).trim() &&
                  customer.createdBy === item.organization
          );
            const status = customerExists ? "Exists" : "New";
            return (
              <TableRow key={index}>
                {updatedColDefs.map((col, colIndex) => {
                  return (
                    <TableCell key={colIndex}>
                      {col.id === "status" ? (
                        <span
                          style={{ color: status === "New" ? "green" : "red" }}
                        >
                          {status}
                        </span>
                      ) : item[col.id] && item[col.id].length > 10 ? (
                        item[col.id].substring(0, 10) + "..."
                      ) : (
                        item[col.id]
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </TblContainer>
      <TblPagination />
      <Controls.Button text="Submit" onClick={handleSubmit} />
      <div style={{ marginTop: 20 }}>
       Note: <strong>New will be Added </strong>
        <br />
        {" "}<strong style={{marginLeft:"20px"}}>Existing will be not Added </strong>
      </div>
    </div>
  );
};

export default SaveCustomersFromFile;
